import { render } from "./BankingWidget.vue?vue&type=template&id=67529a30"
import script from "./BankingWidget.vue?vue&type=script&lang=js"
export * from "./BankingWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__